<template>
  <div class="ml-item-box">
    <img
      :src="
        headerPhoto
          ? $global.imgUrl + headerPhoto
          : require('@/assets/img/mobile-img/jigou-logo.png')
      "
      alt=""
    />

    <h2 v-html="name"></h2>
  </div>
</template>

<script>
export default {
  // 头像 名字
  props: ["headerPhoto", "name"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightName() {
    //   return this.name.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>

<style scoped lang="scss">
.ml-item-box {
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding-bottom: 15px;
  img {
    margin-right: 12px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }
  h2 {
    flex: 1;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>